var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotificationBar",class:_vm.level},[_c('Icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }